import React from 'react'
import { withRouter } from 'react-router-dom'

import Card from '../../../components/card'
import { AuthContext } from '../../../main/authProvider'
import GeneralServices from '../../../app/service/generalServices'
import { Button } from 'primereact/button'
import * as popUp from '../../../components/toastr'
import ConstantsUtil from '../../../context/constantsUtil'
import DateIntervalCalendar from '../../../components/calendar/dateIntervalCalendar'
import InputChooseContaBancaria from '../../../components/conciliacaoBancaria/inputChooseContaBancaria'
import './conciliacaoBancaria.css'
import ConciliacaoBancariaService from '../../../app/service/conciliacaoBancaria/conciliacaoBancariaService'
import HandleErrorService from '../../../app/service/handleErrorService'
import AuthService from '../../../app/service/authService'
import SelectMenu from '../../../components/selectMenu'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import ConfirmationDialog from '../../../components/confirmationDialog'
import { Dialog } from 'primereact/dialog'
import EditProvisaoDialog from '../../../components/contasAPagar/provisoes/editProvisaoDialog'
import LancamentoProvisaoComponent from '../../../components/contasAPagar/provisoes/lancamentoProvisaoComponent'
import CheckProvisoesAPagar from '../provisoes/checkProvisoesAPagar'

const PAGE_SIZE = 10

const ESTADO_DEFINITIVA = 'DEFINITIVA'
const ESCOLHA_TIPO_PAG_EXTRATO = 'extrato'

const listaFiltroTipo = [
    { label: 'Todos', value: '' },
    { label: 'Recebimento', value: 'RECEBIMENTO' },
    { label: 'Pagamento', value: 'PAGAMENTO' },
]

const listaFiltroEstado = [
    { label: 'Todos', value: '' },
    { label: 'A conciliar', value: 'SUGESTAO' },
    { label: 'Conciliados', value: 'DEFINITIVA' },
]

const fmtBRL = (valor) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)

class ConciliacaoBancaria extends React.Component {

    constructor(){
        super()
        this.conciliacaoBancariaService = new ConciliacaoBancariaService()
        this.provisaoService = new ProvisaoService()
        this.generalServices = new GeneralServices()
        this.criarProvisaoComponentRef = React.createRef()
    }

    state = {
        selectedContaBancaria: '',
        selectedContaBancariaLabel: '',
        inputContaBancariaErrorClass: '',

        selectedDateFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,
        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',
        isSearching: false,
        habilitaBusca: true,

        // totais vindos da API — usados nos chips de resumo
        qtdTotalNoExtrato: 0,
        qtdEntradas:       0,
        qtdSaidas:         0,
        qtdConciliados:    0,
        qtdPendentes:      0,

        // lista de pares { extrato, provisao, estado } vindos da API
        // estado pode ser SUGESTAO ou DEFINITIVA
        pares: [],

        // quando o usuário troca a provisão sugerida no picker, guardamos a escolha aqui
        // formato: { idLancamentoBancario: provisaoObject }
        mapExtratoProvisaoSelecionadaNoPicker: {},

        temMais:     false,
        loadingMais: false,

        displayPickerModeDialog: false,
        displayPickerDialog: false,
        extratoIdParaPicker: null,
        parParaPicker: null,
        pickerPreSearchConfig: null,

        filtroTipo:   'PAGAMENTO',
        filtroEstado: 'SUGESTAO',

        parToDeleteProvisao: null,
        displayConfirmDeleteProvisaoDialog: false,
        displayConfirmDeleteRecorrenciaDialog: false,
        provisoesRecorrentesFuturas: [],

        parToEdit: null,
        provisaoIdToEdit: null,
        parcelaProvisaoUuidToEdit: null,
        displayEditProvisaoDialog: false,

        displayConfirmDatasDiferentesDialog: false,
        parToConciliarComDatasDiferentes: null,

        displayConfirmConciliacaoTipoDiferenteDialog: false,
        parToConciliarAposConfirmacao: null,

        displayConfirmDesfazerConciliacaoDialog: false,
        parToDesfazerConciliacao: null,

        displayChooseTipoPagamentoConciliadoDialog: false,
        parToChooseTipoPagamento: null,

        displayCriarProvisaoDialog: false,
        parToCreate: null,

        disableSaveButton: false,
    }

    // ── Conta bancária ────────────────────────────────────────────────────────

    handleSelectionContaBancariaChange = async (selectedContaBancaria, selectedContaBancariaLabel) => {
        await this.setState({selectedContaBancaria})
        await this.setState({selectedContaBancariaLabel})
    }

    // ── Filtros de data ───────────────────────────────────────────────────────

    handleFilterDateChange = (selectedDateFilterType) => {
        this.setState({selectedDateFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.setState({initialDate})
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})
        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})
    }

    resetView = () => {
        this.setState({inputContaBancariaErrorClass: ''})
        this.setState({missingFilterType: false})
        this.setState({missingAnyDate: false})
    }

    checkData = () => {
        var check = true

        if (!this.state.selectedContaBancaria) {
            this.setState({inputContaBancariaErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        if (!this.state.selectedDateFilterType) {
            this.setState({missingFilterType: true})
            check = false
        }

        if (!this.state.initialDate || !this.state.finalDate) {
            this.setState({missingAnyDate: true})
            check = false
        }

        if (this.state.initialDate && this.state.finalDate) {
            if (this.state.initialDateView > this.state.finalDateView) {
                popUp.infoPopUp(ConstantsUtil.dataInicialAnteriorFinalMessage)
                check = false
            }
        }

        return check
    }

    callSearch = () => {
        this.resetView()
        if (this.checkData()) {
            this.search()
        }
    }

    // ── Atualiza os totais do resumo com o retorno da API ─────────────────────

    atualizarTotaisNoState = (responseData) => {
        this.setState({qtdTotalNoExtrato: responseData.qtdTotalNoExtrato})
        this.setState({qtdEntradas:       responseData.qtdEntradas})
        this.setState({qtdSaidas:         responseData.qtdSaidas})
        this.setState({qtdConciliados:    responseData.qtdConciliados})
        this.setState({qtdPendentes:      responseData.qtdPendentes})
    }

    // ── Busca inicial ─────────────────────────────────────────────────────────

    montaFichaBancariaInputDTO = () => {
        let fichaBancariaInputDTO = {
            contaBancariaId: this.state.selectedContaBancaria.id,
            dataInicial: this.state.initialDate,
            dataFinal: this.state.finalDate,
            tipoLancamentoBancario: this.state.filtroTipo,
            estadoConciliacao: this.state.filtroEstado,
        }
        return fichaBancariaInputDTO
    }

    search = () => {
        this.setState({isSearching: true})

        const fichaBancariaInputDTO = this.montaFichaBancariaInputDTO()
        
        // busca inicial sempre começa do índice 0
        fichaBancariaInputDTO.rowIndex = 0
        fichaBancariaInputDTO.quantidade = PAGE_SIZE

        this.conciliacaoBancariaService.searchByDateInterval(fichaBancariaInputDTO)
        .then(response => {
            const lista = response.data.conciliacaoBancariaList || []

            this.atualizarTotaisNoState(response.data)
            this.setState({pares: lista})
            this.setState({mapExtratoProvisaoSelecionadaNoPicker: {}})
            this.setState({habilitaBusca: false})
            this.setState({isSearching: false})
            this.setState({expandidoId: null})
            this.setState({buscaPicker: ''})
            this.setState({temMais: lista.length === PAGE_SIZE})
            this.setState({loadingMais: false})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({isSearching: false})
        })
    }

    voltar = () => {
        this.setState({habilitaBusca: true})
        this.setState({pares: []})
        this.setState({mapExtratoProvisaoSelecionadaNoPicker: {}})
        this.setState({expandidoId: null})
        this.setState({temMais: false})
        this.setState({loadingMais: false})
    }

    // ── Carregar mais (paginação) ─────────────────────────────────────────────

    carregarMais = () => {
        this.setState({loadingMais: true})

        const fichaBancariaInputDTO = this.montaFichaBancariaInputDTO()
        
        // rowIndex = tamanho da lista atual — busca a partir do próximo item ainda não carregado
        fichaBancariaInputDTO.rowIndex = this.state.pares.length
        fichaBancariaInputDTO.quantidade = PAGE_SIZE

        this.conciliacaoBancariaService.searchByDateInterval(fichaBancariaInputDTO)
        .then(response => {
            const lista = response.data.conciliacaoBancariaList || []

            // junta os pares novos com os que já estavam na tela
            const paresAtualizados = this.state.pares.concat(lista)

            this.atualizarTotaisNoState(response.data)
            this.setState({pares: paresAtualizados})
            this.setState({loadingMais: false})
            this.setState({temMais: lista.length === PAGE_SIZE})
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({loadingMais: false})
        })
    }

    // ── Substitui um par na lista pelo par atualizado que voltou da API ─────────

    atualizarParNaLista = (parAtualizado) => {
        // copia a lista para não modificar o state diretamente
        let paresAtualizados = this.state.pares

        // encontra o índice do par que mudou e substitui só ele
        for (let i = 0; i < paresAtualizados.length; i++) {
            const a = paresAtualizados[i]
            const b = parAtualizado
            const mesmoExtrato = a.extrato?.idLancamentoBancario != null
                && a.extrato.idLancamentoBancario === b.extrato?.idLancamentoBancario
            const mesmaProvisao = a.extrato?.idLancamentoBancario == null
                && a.provisao?.idParcelaProvisao === b.provisao?.idParcelaProvisao
            if (mesmoExtrato || mesmaProvisao) {
                paresAtualizados[i] = parAtualizado
                break
            }
        }

        this.setState({pares: paresAtualizados})
    }

    // ── Conciliar ─────────────────────────────────────────────────────────────

    conciliarRow = (par) => {
        if (!par.extrato) return

        const provisaoSelecionadaNoPicker = this.state.mapExtratoProvisaoSelecionadaNoPicker[par.extrato.idLancamentoBancario]
        const provisaoParaConciliar = provisaoSelecionadaNoPicker || par.provisao

        if (GeneralServices.formatTo2CasasDecimais(par.extrato.valor) !== GeneralServices.formatTo2CasasDecimais(provisaoParaConciliar.valor)) {
            popUp.errorPopUp('Extrato e Provisão possuem valores diferentes.')
            return
        }

        if (par.extrato.data !== provisaoParaConciliar.data) {
            this.setState({
                displayConfirmDatasDiferentesDialog: true,
                parToConciliarComDatasDiferentes: par,
            })
            return
        }

        const tipoProv  = provisaoParaConciliar?.tipoDePagamento
        const tipoExtr  = par.extrato?.tipoDePagamento
        const origensDocumentoFiscal = [
            ConstantsUtil.origemProvisaoImportacaoNF,
            ConstantsUtil.origemProvisaoNFManual,
            ConstantsUtil.origemProvisaoImportacaoNFSe,
        ]

        if (tipoProv && tipoExtr && tipoProv.id !== tipoExtr.id) {
            if (origensDocumentoFiscal.includes(provisaoParaConciliar.origemProvisao)) {
                this.setState({
                    displayConfirmConciliacaoTipoDiferenteDialog: true,
                    parToConciliarAposConfirmacao: par,
                })
                return
            }

            if (provisaoParaConciliar.origemProvisao === ConstantsUtil.origemProvisaoOutroasProvisoesManuais) {

                // extrato com tipo "NÃO IDENTIFICADO": nem pergunta, usa o tipo de pagamento da provisão como definitivo
                if (tipoExtr.nome === ConstantsUtil.naoIdentificadoLabel) {
                    this.doConciliarRow({ ...par, tipoDePagamentoConciliado: tipoProv })
                    return
                }

                this.setState({
                    displayChooseTipoPagamentoConciliadoDialog: true,
                    parToChooseTipoPagamento: par,
                })
                return
            }
        }

        this.doConciliarRow(par)
    }

    confirmConciliacaoDatasDiferentes = () => {
        const par = this.state.parToConciliarComDatasDiferentes
        this.setState({
            displayConfirmDatasDiferentesDialog: false,
            parToConciliarComDatasDiferentes: null,
        })
        this.doConciliarRow(par)
    }

    hideConfirmDatasDiferentesDialog = () => {
        this.setState({
            displayConfirmDatasDiferentesDialog: false,
            parToConciliarComDatasDiferentes: null,
        })
    }

    confirmConciliacaoTipoDiferente = () => {
        const par = this.state.parToConciliarAposConfirmacao
        this.setState({
            displayConfirmConciliacaoTipoDiferenteDialog: false,
            parToConciliarAposConfirmacao: null,
        })
        this.doConciliarRow(par)
    }

    hideConfirmConciliacaoTipoDiferenteDialog = () => {
        this.setState({
            displayConfirmConciliacaoTipoDiferenteDialog: false,
            parToConciliarAposConfirmacao: null,
        })
    }

    chooseTipoPagamentoConciliado = (escolha) => {
        const par = this.state.parToChooseTipoPagamento
        const provisaoParaConciliar = this.state.mapExtratoProvisaoSelecionadaNoPicker[par.extrato?.idLancamentoBancario] || par.provisao
        const tipoConciliado = escolha === ESCOLHA_TIPO_PAG_EXTRATO
            ? par.extrato?.tipoDePagamento
            : provisaoParaConciliar?.tipoDePagamento

        this.setState({
            displayChooseTipoPagamentoConciliadoDialog: false,
            parToChooseTipoPagamento: null,
        })
        this.doConciliarRow({ ...par, tipoDePagamentoConciliado: tipoConciliado })
    }

    hideChooseTipoPagamentoConciliadoDialog = () => {
        this.setState({
            displayChooseTipoPagamentoConciliadoDialog: false,
            parToChooseTipoPagamento: null,
        })
    }

    doConciliarRow = (par) => {

        AuthService.startBlockUi()

        // se o usuário trocou a provisão no picker, usa ela; senão usa a sugestão da API
        const provisaoSelecionadaNoPicker = this.state.mapExtratoProvisaoSelecionadaNoPicker[par.extrato.idLancamentoBancario]
        const provisaoParaConciliar = provisaoSelecionadaNoPicker || par.provisao

        const conciliacaoBancariaDTO = {
            extrato:  par.extrato,
            provisao: provisaoParaConciliar,
            estado:   par.estado,
            tipoDePagamentoConciliado: par.tipoDePagamentoConciliado || null,
        }

        let fichaBancariaInputDTO = this.montaFichaBancariaInputDTO()
        fichaBancariaInputDTO.conciliacaoBancaria = conciliacaoBancariaDTO

        this.conciliacaoBancariaService.conciliar(fichaBancariaInputDTO)
        .then(response => {
            const parAtualizado = response.data.conciliacaoBancariaList[0]

            // remove a seleção do picker para esse extrato, já que foi conciliado
            const novoMapSelecionadaNoPicker = {}
            for (const extratoId in this.state.mapExtratoProvisaoSelecionadaNoPicker) {
                if (Number(extratoId) !== par.extrato.idLancamentoBancario) {
                    novoMapSelecionadaNoPicker[extratoId] = this.state.mapExtratoProvisaoSelecionadaNoPicker[extratoId]
                }
            }

            this.atualizarTotaisNoState(response.data)
            this.setState({mapExtratoProvisaoSelecionadaNoPicker: novoMapSelecionadaNoPicker})
            popUp.successPopUp('Conciliação realizada!')

            // se o filtro está em "A conciliar", o item conciliado some da lista e buscamos o próximo
            if (this.state.filtroEstado === 'SUGESTAO') {

                // remove o item conciliado da lista
                const paresAtualizados = []
                for (const p of this.state.pares) {
                    // console.log("===== começa aqui =====")
                    // console.log("p: ", p)
                    // console.log("par: ", par)
                    // console.log("===== termina aqui =====")
                    // console.log("\n\n")
                    if ( !p.extrato || (p.extrato.idLancamentoBancario !== par.extrato.idLancamentoBancario) ) {
                        paresAtualizados.push(p)
                    }
                }
                this.setState({pares: paresAtualizados})

                // busca o próximo item pendente para preencher o lugar do conciliado
                // rowIndex = tamanho da lista após a remoção (próximo índice no banco)
                const fichaBancariaProximoDTO = this.montaFichaBancariaInputDTO()
                fichaBancariaProximoDTO.rowIndex = paresAtualizados.length
                fichaBancariaProximoDTO.quantidade = 1

                this.conciliacaoBancariaService.searchByDateInterval(fichaBancariaProximoDTO)
                .then(responseProximo => {
                    const listaProximo = responseProximo.data.conciliacaoBancariaList || []

                    // adiciona o próximo item pendente ao final da lista
                    const paresComProximo = paresAtualizados.concat(listaProximo)
                    this.setState({pares: paresComProximo})

                    // se veio 1 item, pode ter mais; se veio 0, acabaram os pendentes
                    this.setState({temMais: listaProximo.length === 1})
                })
                .catch(error => {
                    HandleErrorService.handleError(error)
                })

            } else {
                // nos outros filtros, só atualiza o estado do item na lista
                this.atualizarParNaLista(parAtualizado)
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            console.log("error em /conciliar: ", error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    // ── Desfazer conciliação ──────────────────────────────────────────────────

    // clique no "Desfazer": só abre o dialog de confirmação, ainda não chama a API
    callDesfazerConciliacao = (par, e) => {
        if (e) {
            e.stopPropagation()
        }
        this.setState({
            displayConfirmDesfazerConciliacaoDialog: true,
            parToDesfazerConciliacao: par,
        })
    }

    confirmDesfazerConciliacao = () => {
        const par = this.state.parToDesfazerConciliacao
        this.hideConfirmDesfazerConciliacaoDialog()
        this.desconciliarRow(par)
    }

    hideConfirmDesfazerConciliacaoDialog = () => {
        this.setState({
            displayConfirmDesfazerConciliacaoDialog: false,
            parToDesfazerConciliacao: null,
        })
    }

    desconciliarRow = (par) => {

        AuthService.startBlockUi()

        let fichaBancariaInputDTO = this.montaFichaBancariaInputDTO()
        fichaBancariaInputDTO.conciliacaoBancaria = par

        this.conciliacaoBancariaService.desfazerConciliacao(fichaBancariaInputDTO)
        .then(response => {
            const parAtualizado = response.data.conciliacaoBancariaList[0]
            this.atualizarParNaLista(parAtualizado)
            this.atualizarTotaisNoState(response.data)
            popUp.successPopUp('Conciliação desfeita!')
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })        
    }

    // ── Filtros de tipo e estado ──────────────────────────────────────────────

    handleFiltroTipoChange = (event) => {
        this.setState({filtroTipo: event.target.value})
    }

    handleFiltroEstadoChange = (event) => {
        this.setState({filtroEstado: event.target.value})
    }

    // ── Picker (busca de provisão via dialog) ────────────────────────────────

    openPickerDialog = (extratoId, par) => {
        this.setState({ displayPickerModeDialog: true, extratoIdParaPicker: extratoId, parParaPicker: par })
    }

    hidePickerModeDialog = () => {
        this.setState({ displayPickerModeDialog: false })
    }

    selectPickerMode = (mode) => {
        const extrato = this.state.parParaPicker?.extrato
        let pickerPreSearchConfig = null

        if (mode === 1) {
            pickerPreSearchConfig = {
                pesquisaAvancada: true,
                dataBase: extrato?.data,
                valorMinimo: extrato?.valor,
                valorMaximo: extrato?.valor,
            }
        } else if (mode === 2) {
            pickerPreSearchConfig = {
                pesquisaAvancada: true,
                dataBase: extrato?.data,
                tipoDePagamento: extrato?.tipoDePagamento,
            }
        }
        // mode === 3: pickerPreSearchConfig permanece null → pesquisa geral sem pré-seleção

        this.setState({
            displayPickerModeDialog: false,
            displayPickerDialog: true,
            pickerPreSearchConfig,
        })
    }

    hidePickerDialog = () => {
        this.setState({ displayPickerDialog: false, extratoIdParaPicker: null, parParaPicker: null, pickerPreSearchConfig: null })
    }

    onSelectProvisaoPicker = (rowData) => {
        // rowData pode ser provisão (tem parcelaProvisaoList) ou parcelaProvisao (tem uuid)
        const uuid = rowData.uuid ?? rowData.parcelaProvisaoList?.[0]?.uuid
        if (!uuid) return

        const extratoId = this.state.extratoIdParaPicker
        this.hidePickerDialog()

        this.conciliacaoBancariaService.searchConciliacaoProvisaoByUuidParcela(uuid)
        .then(response => {
            const novoMapSelecionadaNoPicker = {
                ...this.state.mapExtratoProvisaoSelecionadaNoPicker,
                [extratoId]: response.data,
            }
            this.setState({ mapExtratoProvisaoSelecionadaNoPicker: novoMapSelecionadaNoPicker })
        })
        .catch(error => HandleErrorService.handleError(error))
    }

    // ── Excluir provisão ─────────────────────────────────────────────────────

    callDeleteProvisao = (par) => {
        if (par.provisao.tipo === 'PAGAMETNO_PARCELA_PROVISAO_UNIFICACAO') {
            popUp.infoPopUp('Não é possível excluir uma provisão de unificação.')
            return
        }

        this.setState({ parToDeleteProvisao: par })

        if (par.provisao.recorrencia) {
            this.provisaoService.buscaProvisoesRecorrentesFuturas(par.provisao.provisaoId)
            .then(response => {
                this.setState({
                    provisoesRecorrentesFuturas: response.data.provisaoList,
                    displayConfirmDeleteRecorrenciaDialog: true,
                })
            })
            .catch(error => HandleErrorService.handleError(error))
        } else {
            this.setState({ displayConfirmDeleteProvisaoDialog: true })
        }
    }

    confirmDeleteProvisao = () => {
        const provisaoId = this.state.parToDeleteProvisao.provisao.provisaoId
        AuthService.startBlockUi()
        this.provisaoService.deleteById(provisaoId)
        .then(() => {
            popUp.successPopUp('Provisão deletada com sucesso!')
            this.removerParDaLista(this.state.parToDeleteProvisao)
            this.hideConfirmDeleteProvisaoDialog()
            this.hideConfirmDeleteRecorrenciaDialog()
        })
        .catch(error => HandleErrorService.handleError(error))
        .finally(() => AuthService.stopBlockUi())
    }

    confirmDeleteProvisoesRecorrentes = () => {
        const provisaoId = this.state.parToDeleteProvisao.provisao.provisaoId
        AuthService.startBlockUi()
        this.provisaoService.deleteRecorrenciasByProvisaoBase(provisaoId)
        .then(() => {
            popUp.successPopUp('Provisões recorrentes deletadas com sucesso!')
            this.removerParDaLista(this.state.parToDeleteProvisao)
            this.hideConfirmDeleteProvisaoDialog()
            this.hideConfirmDeleteRecorrenciaDialog()
        })
        .catch(error => HandleErrorService.handleError(error))
        .finally(() => AuthService.stopBlockUi())
    }

    removerParDaLista = (par) => {
        const paresAtualizados = this.state.pares.filter(p =>
            p.provisao?.idParcelaProvisao !== par.provisao?.idParcelaProvisao
        )
        this.setState({ pares: paresAtualizados })
    }

    hideConfirmDeleteProvisaoDialog = () => {
        this.setState({ displayConfirmDeleteProvisaoDialog: false, parToDeleteProvisao: null })
    }

    hideConfirmDeleteRecorrenciaDialog = () => {
        this.setState({
            displayConfirmDeleteRecorrenciaDialog: false,
            provisoesRecorrentesFuturas: [],
            parToDeleteProvisao: null,
        })
    }

    // ── Editar provisão ──────────────────────────────────────────────────────

    callEditProvisao = (par) => {
        const provisaoSelecionadaNoPicker = par.extrato
            ? this.state.mapExtratoProvisaoSelecionadaNoPicker[par.extrato.idLancamentoBancario]
            : null
        const provisaoParaEditar = provisaoSelecionadaNoPicker || par.provisao
        this.setState({
            parToEdit: par,
            provisaoIdToEdit: provisaoParaEditar.provisaoId,
            parcelaProvisaoUuidToEdit: provisaoParaEditar.uuidParcelaProvisao,
            displayEditProvisaoDialog: true,
        })
    }

    hideEditProvisaoDialog = (body) => {

        this.setState({displayEditProvisaoDialog: false})

        if(!body || !body.isAfterEdit){
            this.setState({
                provisaoIdToEdit: null,
                parcelaProvisaoUuidToEdit: null,
                parToEdit: null
            })
        }

    }

    reRenderEditProvisaoDialog = async () => {
        AuthService.startBlockUi()
        await this.setState({ displayEditProvisaoDialog: false })
        await this.generalServices.sleep(500)
        await this.setState({ displayEditProvisaoDialog: true })
        AuthService.stopBlockUi()
    }

    onSaveEditProvisao = () => {
        this.conciliacaoBancariaService.searchConciliacaoProvisaoByUuidParcela(this.state.parcelaProvisaoUuidToEdit)
        .then(response => {
            const novaProvisao = response.data
            const parAntigo = this.state.parToEdit
            const extratoId = parAntigo.extrato?.idLancamentoBancario

            if (extratoId != null && this.state.mapExtratoProvisaoSelecionadaNoPicker[extratoId]) {
                const novoMap = {
                    ...this.state.mapExtratoProvisaoSelecionadaNoPicker,
                    [extratoId]: novaProvisao,
                }
                this.setState({ mapExtratoProvisaoSelecionadaNoPicker: novoMap, parToEdit: null, parcelaProvisaoUuidToEdit: null })
            } else {
                const paresAtualizados = this.state.pares.map(p =>
                    p.provisao?.idParcelaProvisao === parAntigo.provisao?.idParcelaProvisao
                        ? { ...p, provisao: novaProvisao }
                        : p
                )
                this.setState({ pares: paresAtualizados, parToEdit: null, parcelaProvisaoUuidToEdit: null })
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    // ── Criar provisão ───────────────────────────────────────────────────────

    callCriarProvisao = (par) => {
        this.setState({ displayCriarProvisaoDialog: true, parToCreate: par })
    }

    hideCriarProvisaoDialog = () => {
        this.setState({ displayCriarProvisaoDialog: false, parToCreate: null })
    }

    onSuccessLancamento = (novaProvisaoCriada) => {
        const uuidNovaParcelaCriada = novaProvisaoCriada.parcelaProvisaoList[0]?.uuid
        const parDoExtrato = this.state.parToCreate

        this.setState({ displayCriarProvisaoDialog: false, parToCreate: null })

        this.conciliacaoBancariaService.searchConciliacaoProvisaoByUuidParcela(uuidNovaParcelaCriada)
        .then(response => {
            const novaProvisao = response.data
            const paresAtualizados = this.state.pares.map(p =>
                p.extrato?.idLancamentoBancario === parDoExtrato.extrato?.idLancamentoBancario
                    ? { ...p, provisao: novaProvisao }
                    : p
            )
            this.setState({ pares: paresAtualizados })
        })
        .catch(error => HandleErrorService.handleError(error))
    }

    disableSaveButton = () => {
        this.setState({disableSaveButton: true})
    }

    enableSaveButton = () => {
        this.setState({disableSaveButton: false})
    }

    callSave = () => {
        // quem desabilita/habilita o botão é o próprio LancamentoProvisaoComponent
        this.criarProvisaoComponentRef.current.callSave()
    }

    // ── Render ────────────────────────────────────────────────────────────────

    render() {
        const {
            isSearching,
            habilitaBusca,
            mapExtratoProvisaoSelecionadaNoPicker,
            temMais,
            loadingMais,
        } = this.state

        // ── botão de buscar / nova busca ──
        const renderActionButton = () => {
            if (isSearching) {
                return <Button label="Buscando..." icon="pi pi-spin pi-spinner" disabled />
            }
            if (habilitaBusca) {
                return <Button label="Buscar" icon="pi pi-search" onClick={this.callSearch} />
            }
            return <Button label="Nova busca" icon="pi pi-undo" className="p-button-outlined" onClick={this.voltar} />
        }

        // ── chips de resumo com os totais vindos da API ──
        const renderSummary = () => {
            if (habilitaBusca) return null
            return (
                <div className="cb-summary">
                    {/* <div className="cb-summary-chip cb-chip-total">
                        <span className="cb-chip-num">{this.state.qtdTotalNoExtrato}</span>
                        <span className="cb-chip-lbl">Total no extrato</span>
                    </div> */}
                    {/* <div className="cb-summary-chip cb-chip-entrada">
                        <i className="pi pi-arrow-circle-down" />
                        <span className="cb-chip-num">{this.state.qtdEntradas}</span>
                        <span className="cb-chip-lbl">Entradas</span>
                    </div> */}
                    <div className="cb-summary-chip cb-chip-saida">
                        <i className="pi pi-arrow-circle-up" />
                        <span className="cb-chip-num">{this.state.qtdSaidas}</span>
                        <span className="cb-chip-lbl">Saídas</span>
                    </div>
                    <div className="cb-summary-chip cb-chip-ok">
                        <i className="pi pi-check-circle" />
                        <span className="cb-chip-num">{this.state.qtdConciliados}</span>
                        <span className="cb-chip-lbl">Conciliados</span>
                    </div>
                    <div className="cb-summary-chip cb-chip-warn">
                        <i className="pi pi-exclamation-circle" />
                        <span className="cb-chip-num">{this.state.qtdPendentes}</span>
                        <span className="cb-chip-lbl">Pendentes</span>
                    </div>
                </div>
            )
        }

        // ── slot direito: exibe a provisão de acordo com o estado do par ──
        const renderProvSlot = (par) => {
            const extratoId = par.extrato?.idLancamentoBancario

            // provisão a exibir: picker tem prioridade sobre a sugestão da API
            const provisaoSelecionadaNoPicker = extratoId != null ? mapExtratoProvisaoSelecionadaNoPicker[extratoId] : null
            const provisaoParaExibir = provisaoSelecionadaNoPicker || par.provisao

            // estado DEFINITIVA: conciliação confirmada — bloco verde
            if (par.estado === ESTADO_DEFINITIVA) {
                return (
                    <div className="cb-prov-slot cb-prov-conciliada">
                        <div className="cb-prov-slot-head">
                            <span className="cb-tag cb-tag--green">
                                <i className="pi pi-check" /> Conciliado
                            </span>
                            <button className="cb-link-btn cb-link-danger"
                                onClick={(e) => this.callDesfazerConciliacao(par, e)}>
                                Desfazer
                            </button>
                        </div>
                        <div className="cb-prov-pessoa">{par.provisao.descricao}</div>
                        <div className="cb-prov-meta">
                            <span><i className="pi pi-calendar" /> {par.provisao.data}</span>
                        </div>
                        <div className="cb-prov-valor">{fmtBRL(par.provisao.valor)}</div>
                    </div>
                )
            }

            // existe provisão (sugestão da API ou escolhida no picker)
            if (provisaoParaExibir) {
                return (
                    <div className="cb-prov-slot cb-prov-sugerida">
                        <div className="cb-prov-slot-head">
                            {extratoId != null && (
                                <span className="cb-tag cb-tag--blue-soft">Sugestão do sistema</span>
                            )}
                            {extratoId != null && (
                                <div className="cb-prov-actions">
                                    <button className="cb-link-btn" onClick={() => this.openPickerDialog(extratoId, par)}>
                                        <i className="pi pi-pencil" /> Trocar
                                    </button>
                                    <button className="cb-link-btn" onClick={() => this.callEditProvisao(par)}>
                                        <i className="pi pi-pencil" /> Editar
                                    </button>
                                </div>
                            )}
                            {extratoId == null && (
                                <div className="cb-prov-actions">
                                    <button className="cb-link-btn" onClick={() => this.callEditProvisao(par)}>
                                        <i className="pi pi-pencil" /> Editar
                                    </button>
                                    <button className="cb-link-btn cb-link-danger" onClick={() => this.callDeleteProvisao(par)}>
                                        <i className="pi pi-trash" /> Excluir
                                    </button>
                                </div>
                            )}

                        </div>
                        <div className="cb-prov-pessoa">{provisaoParaExibir.descricao}</div>
                        <div className="cb-prov-meta">
                            <span><i className="pi pi-calendar" /> {provisaoParaExibir.data}</span>
                        </div>
                        <div className="cb-prov-valor">{fmtBRL(provisaoParaExibir.valor)}</div>
                    </div>
                )
            }

            // sem provisão — nem sugestão nem escolha do picker
            return (
                <div className="cb-prov-slot cb-prov-vazia">
                    <i className="pi pi-question-circle cb-prov-vazia-icon" />
                    <span className="cb-prov-vazia-txt">Sem sugestão automática</span>
                    {extratoId != null && (
                        <div className="cb-prov-vazia-actions">
                            <button className="cb-link-btn" onClick={() => this.openPickerDialog(extratoId, par)}>
                                <i className="pi pi-search" /> Buscar provisão
                            </button>
                            <button className="cb-link-btn" onClick={() => this.callCriarProvisao(par)}>
                                <i className="pi pi-plus" /> Criar Provisão
                            </button>
                        </div>
                    )}
                </div>
            )
        }

        // ── linha completa de cada par extrato/provisão ──
        const renderRow = (par) => {
            const extratoId    = par.extrato?.idLancamentoBancario
            const rowKey       = extratoId ?? ('prov-' + par.provisao?.idParcelaProvisao)
            const isEntrada    = par.extrato?.tipo === 'ENTRADA'
            const isConciliado = par.estado === ESTADO_DEFINITIVA

            // provisão a usar ao clicar em Conciliar (picker tem prioridade sobre sugestão da API)
            const provisaoSelecionadaNoPicker = extratoId != null ? mapExtratoProvisaoSelecionadaNoPicker[extratoId] : null
            const provisaoParaConciliar = provisaoSelecionadaNoPicker || par.provisao
            const podeConciliar = par.extrato != null && provisaoParaConciliar != null

            const rowTipoClass = par.extrato == null ? '' : (isEntrada ? 'cb-row-entrada' : 'cb-row-saida')

            return (
                <div key={rowKey} className={`cb-row ${rowTipoClass} ${isConciliado ? 'cb-row--done' : ''}`}>

                    <div className="cb-row-inner">

                        {/* lado esquerdo: dados do extrato bancário */}
                        {par.extrato == null
                            ? <div className="cb-extrato-slot cb-extrato-vazio">
                                  <i className="pi pi-question-circle cb-prov-vazia-icon" />
                                  <span className="cb-prov-vazia-txt">Sem lançamento no extrato</span>
                              </div>
                            : <div className="cb-extrato-slot">
                                  <span className={`cb-tipo-badge ${isEntrada ? 'cb-tipo-entrada' : 'cb-tipo-saida'}`}>
                                      <i className={isEntrada ? 'pi pi-arrow-circle-down' : 'pi pi-arrow-circle-up'} />
                                      {isEntrada ? 'Entrada' : 'Saída'}
                                  </span>
                                  <div className="cb-extrato-desc">{par.extrato.descricao}</div>
                                  {par.extrato.descricaoExtrato && (
                                      <div className="cb-extrato-desc-extrato">
                                          Descrição no extrato: {par.extrato.descricaoExtrato}
                                      </div>
                                  )}
                                  <div className="cb-extrato-meta">
                                      <span><i className="pi pi-calendar" /> {par.extrato.data}</span>
                                  </div>
                                  <div className={`cb-extrato-valor ${isEntrada ? 'cb-val--pos' : 'cb-val--neg'}`}>
                                      {fmtBRL(par.extrato.valor)}
                                  </div>
                              </div>
                        }

                        {/* centro: botão de conciliar ou ícone de conciliado */}
                        <div className="cb-row-connector">
                            {isConciliado
                                ? <i className="pi pi-check-circle cb-connector-icon cb-connector-done" />
                                : <Button
                                    label="Conciliar"
                                    icon="pi pi-link"
                                    className={`cb-btn-conciliar-row ${!podeConciliar ? 'cb-btn-conciliar-row--disabled' : ''}`}
                                    disabled={!podeConciliar}
                                    onClick={() => this.conciliarRow(par)}
                                  />
                            }
                        </div>

                        {/* lado direito: dados da provisão */}
                        {renderProvSlot(par)}

                    </div>

                </div>
            )
        }

        const renderContent = () => {
            if (habilitaBusca) return null
            return (
                <div className="cb-content">
                    <div className="cb-col-header">
                        <div className="cb-col-header-left">
                            <i className="pi pi-building" />
                            Extrato Bancário
                        </div>
                        <div className="cb-col-header-center" />
                        <div className="cb-col-header-right">
                            <i className="pi pi-file" />
                            Provisão
                        </div>
                    </div>
                    {this.state.pares.map(par => renderRow(par))}

                    {(temMais || loadingMais) && (
                        <div className="cb-load-more">
                            <button
                                className="cb-load-more-btn"
                                onClick={this.carregarMais}
                                disabled={loadingMais}
                            >
                                {loadingMais
                                    ? <><i className="pi pi-spin pi-spinner" /> Carregando...</>
                                    : <><i className="pi pi-plus-circle" /> Carregar mais</>
                                }
                            </button>
                        </div>
                    )}
                </div>
            )
        }

        const renderConfirmDeleteProvisaoDialog = () => (
            <ConfirmationDialog
                visible={this.state.displayConfirmDeleteProvisaoDialog}
                header="Deletar Lançamento de Provisão"
                confimationMessage="Deseja Confirmar?"
                confirm={this.confirmDeleteProvisao}
                hide={this.hideConfirmDeleteProvisaoDialog}
            />
        )

        const confirmDeleteRecorrenteFooter = () => (
            <>
                <Button label="Deletar apenas essa" onClick={this.confirmDeleteProvisao} />
                <Button
                    label="Deletar todas"
                    className="right-button p-button-danger"
                    onClick={this.confirmDeleteProvisoesRecorrentes}
                />
            </>
        )

        const renderConfirmDeleteRecorrenteDialog = () => (
            <Dialog
                visible={this.state.displayConfirmDeleteRecorrenciaDialog}
                style={{ width: '40vw' }}
                header="Deletar Provisão Recorrente"
                modal
                className="p-fluid"
                footer={confirmDeleteRecorrenteFooter}
                onHide={this.hideConfirmDeleteRecorrenciaDialog}
            >
                <div className="col-md-12">
                    Essa é uma provisão recorrente.
                    <br />
                    Deseja deletar apenas essa ou todas as demais?
                    <br />
                    As demais provisões dessa recorrência possuem as seguintes datas de pagamento:
                    <br />
                    {GeneralServices.getDatasPagamentosRecorrenciasFuturas(this.state.provisoesRecorrentesFuturas)}
                </div>
            </Dialog>
        )

        const renderConfirmDatasDiferentesDialog = () => {
            const par = this.state.parToConciliarComDatasDiferentes
            if (!par) return null
            const provisaoParaConciliar = this.state.mapExtratoProvisaoSelecionadaNoPicker[par.extrato?.idLancamentoBancario] || par.provisao
            return (
                <ConfirmationDialog
                    visible={this.state.displayConfirmDatasDiferentesDialog}
                    header="Datas Diferentes"
                    width="800px"
                    confimationMessage={
                        <>
                            {`O extrato bancário possui data ${par.extrato.data} e a provisão possui data ${provisaoParaConciliar.data}.`}
                            <br />
                            {'Deseja prosseguir com a conciliação mesmo assim?'}
                            <br />
                            {'A data de pagamento da provisão será alterada para a mesma data do extrato.'}
                        </>
                    }
                    confirm={this.confirmConciliacaoDatasDiferentes}
                    hide={this.hideConfirmDatasDiferentesDialog}
                />
            )
        }

        const renderConfirmConciliacaoTipoDiferenteDialog = () => (
            <ConfirmationDialog
                visible={this.state.displayConfirmConciliacaoTipoDiferenteDialog}
                header="Tipos de Pagamento Diferentes"
                width="1000px"
                confimationMessage={
                    'O extrato bancário e a provisão possuem tipos de pagamento diferentes. ' +
                    'Por se tratar de uma provisão originada de um documento fiscal, o tipo de pagamento ' +
                    'do lançamento bancário será atualizado automaticamente para corresponder ao da provisão. ' +
                    'Deseja prosseguir com a conciliação?'
                }
                confirm={this.confirmConciliacaoTipoDiferente}
                hide={this.hideConfirmConciliacaoTipoDiferenteDialog}
            />
        )

        const renderConfirmDesfazerConciliacaoDialog = () => {
            const par = this.state.parToDesfazerConciliacao
            if (!par) return null
            return (
                <ConfirmationDialog
                    visible={this.state.displayConfirmDesfazerConciliacaoDialog}
                    header="Desfazer Conciliação"
                    width="600px"
                    confimationMessage={
                        <>
                            {'Deseja realmente desfazer a conciliação abaixo?'}
                            <br /><br />
                            <strong>Extrato:</strong> {`${par.extrato?.descricao} · ${par.extrato?.data} · ${fmtBRL(par.extrato?.valor)}`}
                            <br />
                            <strong>Provisão:</strong> {`${par.provisao?.descricao} · ${par.provisao?.data} · ${fmtBRL(par.provisao?.valor)}`}
                        </>
                    }
                    confirm={this.confirmDesfazerConciliacao}
                    hide={this.hideConfirmDesfazerConciliacaoDialog}
                />
            )
        }

        const renderChooseTipoPagamentoConciliadoDialog = () => {
            const parChoose = this.state.parToChooseTipoPagamento
            if (!parChoose) return null
            const provisaoEscolhida = this.state.mapExtratoProvisaoSelecionadaNoPicker[parChoose.extrato?.idLancamentoBancario] || parChoose.provisao
            const nomeExtr = parChoose.extrato?.tipoDePagamento?.nome || ''
            const nomeProv = provisaoEscolhida?.tipoDePagamento?.nome || ''
            const footer = (
                <>
                    <Button
                        label={`Extrato (${nomeExtr})`}
                        icon="pi pi-credit-card"
                        onClick={() => this.chooseTipoPagamentoConciliado(ESCOLHA_TIPO_PAG_EXTRATO)}
                    />
                    <Button
                        label={`Provisão (${nomeProv})`}
                        icon="pi pi-file"
                        className="p-button-secondary"
                        onClick={() => this.chooseTipoPagamentoConciliado('provisao')}
                    />
                </>
            )
            return (
                <Dialog
                    visible={this.state.displayChooseTipoPagamentoConciliadoDialog}
                    style={{ width: '45vw' }}
                    header="Tipos de Pagamento Diferentes"
                    modal
                    footer={footer}
                    onHide={this.hideChooseTipoPagamentoConciliadoDialog}
                >
                    <div className="col-md-12">
                        O extrato e a provisão possuem tipos de pagamento diferentes.
                        Escolha qual Tipo de Pagamento é o definitivo.
                        <br /><br />
                        <strong>Extrato:</strong> {nomeExtr}
                        <br />
                        <strong>Provisão:</strong> {nomeProv}
                    </div>
                </Dialog>
            )
        }

        const criarProvisaoDialogFooter = (
            <Button
                label="Salvar Lançamento"
                icon="pi pi-save"
                onClick={this.callSave}
                disabled = {this.state.disableSaveButton}
            />
        )

        return (
            <div className="bs-docs-section">
                {renderConfirmDeleteProvisaoDialog()}
                {renderConfirmDeleteRecorrenteDialog()}
                {renderConfirmDatasDiferentesDialog()}
                {renderConfirmConciliacaoTipoDiferenteDialog()}
                {renderConfirmDesfazerConciliacaoDialog()}
                {renderChooseTipoPagamentoConciliadoDialog()}
                <Dialog
                    visible={this.state.displayPickerModeDialog}
                    style={{ width: '38vw' }}
                    header="Buscar Provisão"
                    modal
                    onHide={this.hidePickerModeDialog}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '4px 0' }}>
                        <Button
                            label="Buscar por valores iguais (data do extrato ± 10 dias)"
                            icon="pi pi-dollar"
                            className="p-button-outlined"
                            style={{ justifyContent: 'flex-start' }}
                            onClick={() => this.selectPickerMode(1)}
                        />
                        <Button
                            label="Buscar por tipo de pagamento igual (data do extrato ± 10 dias)"
                            icon="pi pi-credit-card"
                            className="p-button-outlined"
                            style={{ justifyContent: 'flex-start' }}
                            onClick={() => this.selectPickerMode(2)}
                        />
                        <Button
                            label="Pesquisa geral"
                            icon="pi pi-search"
                            className="p-button-outlined"
                            style={{ justifyContent: 'flex-start' }}
                            onClick={() => this.selectPickerMode(3)}
                        />
                    </div>
                </Dialog>

                <Dialog
                    visible={this.state.displayPickerDialog}
                    style={{ width: '95vw' }}
                    header="Buscar Provisão"
                    modal
                    className="p-fluid"
                    onHide={this.hidePickerDialog}
                >
                    {this.state.displayPickerDialog && (
                        <CheckProvisoesAPagar
                            onSelectProvisao={this.onSelectProvisaoPicker}
                            preSearchConfig={this.state.pickerPreSearchConfig}
                        />
                    )}
                </Dialog>
                <Dialog
                    visible={this.state.displayCriarProvisaoDialog}
                    style={{ width: '95vw' }}
                    header="Criar Provisão"
                    modal
                    className="p-fluid"
                    footer={criarProvisaoDialogFooter}
                    onHide={this.hideCriarProvisaoDialog}
                >
                    <div className="col-md-12">
                        {this.state.displayCriarProvisaoDialog && (
                            <LancamentoProvisaoComponent
                                ref={this.criarProvisaoComponentRef}
                                isLancamento
                                disableSaveButton={this.disableSaveButton}
                                enableSaveButton={this.enableSaveButton}
                                onSuccessLancamento={this.onSuccessLancamento}
                                initialTipoDePagamento={this.state.parToCreate?.extrato?.tipoDePagamento}
                                initialValor={this.state.parToCreate?.extrato?.valor}
                                initialDataParcela={this.state.parToCreate?.extrato?.data}
                                disablePrefilledFields
                            />
                        )}
                    </div>
                </Dialog>
                <EditProvisaoDialog
                    visible={this.state.displayEditProvisaoDialog}
                    provisaoId={this.state.provisaoIdToEdit}
                    search={this.onSaveEditProvisao}
                    hideDialog={this.hideEditProvisaoDialog}
                    reRender={this.reRenderEditProvisaoDialog}
                />
                <Card title="Conciliação Bancária">
                    <div className="col-md-12">

                        <div className="row">
                            <div className="col-md-3">
                                <InputChooseContaBancaria
                                    label="Conta Bancária / Aplicação Financeira"
                                    readOnly
                                    noHTMLFormat
                                    selectedContaBancariaLabel={this.state.selectedContaBancariaLabel}
                                    handleSelectionContaBancariaChange={this.handleSelectionContaBancariaChange}
                                    inputContaBancariaErrorClass={this.state.inputContaBancariaErrorClass}
                                    errorContaBancariaMessage="Selecione uma Conta Bancária"
                                    disabled={!habilitaBusca}
                                    excludeAplicacaoFinanceira
                                    excludeInativas
                                />
                            </div>
                            <DateIntervalCalendar
                                htmlFor="SelectDatePeriod"
                                label="Escolher período"
                                handleFilterChange={this.handleFilterDateChange}
                                handleDateChange={this.handleDateChange}
                                missingFilterType={this.state.missingFilterType}
                                missingAnyDate={this.state.missingAnyDate}
                                disabled={!habilitaBusca}
                            />
                            <div className="col-md-2">
                                <label>Tipo</label>
                                <SelectMenu
                                    className="form-control"
                                    name="filtroTipo"
                                    list={listaFiltroTipo}
                                    value={this.state.filtroTipo}
                                    onChange={this.handleFiltroTipoChange}
                                    disabled
                                />
                            </div>
                            <div className="col-md-2">
                                <label>Status</label>
                                <SelectMenu
                                    className="form-control"
                                    name="filtroEstado"
                                    list={listaFiltroEstado}
                                    value={this.state.filtroEstado}
                                    onChange={this.handleFiltroEstadoChange}
                                />
                            </div>
                        </div>

                        <br />
                        {renderActionButton()}
                        <br /><br />

                        {renderSummary()}
                        {renderContent()}

                    </div>
                </Card>
            </div>
        )
    }
}

ConciliacaoBancaria.contextType = AuthContext
export default withRouter(ConciliacaoBancaria)
